module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00399.92367505.jpg";